export const DisplayLang = {
    en: "HU",
    hu: "EN"
};
